export default __webpack_public_path__ + "static/media/mergers@2x.80deac8d.png";